<template>
  <v-card>
    <card-header :title="title" :icon="icon" color="primary" variant="gradient"></card-header>
    <v-card-text>
      <div>
        <simple-table-content :data="data" :columns="columns"></simple-table-content>
      </div>

      <slot name="buttons"></slot>
    </v-card-text>
  </v-card>
</template>

<script>
  import CardHeader from '@/components/cards/CardHeader.vue';
  import SimpleTableContent from '@/components/Tables/SimpleTableContent.vue';

  export default {
    name: "simple-table",
    components: {
      CardHeader,
      SimpleTableContent,
    },
    props: {
      title: {
        type: String,
        required: false,
        default: "List"
      },
      icon: {
        type: String,
        required: false,
        default: "assignment"
      },
      data: {
        type: Array,
        required: true,
      },
      columns: {
        type: Array,
        required: true,
      },
    },
  };
</script>
<style scoped>
  .table-transparent {
    background-color: transparent !important;
  }

  .mt-0 {
    margin-top: 0 !important;
  }
</style>
